module.exports = __webpack_public_path__ + "img/close-primary.c271c7ee.svg";